import React from 'react'
import AdminDash from '../../features/AdminPanel/AdminDashboard/AdminDash'

function AdminDashboard() {
  return (
    <div>
      <AdminDash/>
    </div>
  )
}

export default AdminDashboard
